import React from 'react';
import { Header } from './Header';
import { useLayoutConfig } from '../../../hooks/useLayoutConfig';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';

interface PageLayoutProps {
  children: React.ReactNode;
  title: string;
  sidebar?: React.ReactNode;
  disablePadding?: boolean;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  title,
  sidebar,
  disablePadding,
}) => {
  const { topPadding, sidebarTopOffset } = useLayoutConfig();
  useDocumentTitle(title);

  return (
    <>
      <Header />
      <div style={!disablePadding ? { paddingTop: topPadding } : undefined}>
        {sidebar && (
          <div className="hidden md:block fixed left-0 bottom-0 z-40" style={{ top: sidebarTopOffset }}>
            {sidebar}
          </div>
        )}
        <div className={sidebar ? 'flex-1 md:ml-[60px] overflow-x-hidden' : 'flex-1'}>{children}</div>
      </div>
    </>
  );
};
